import React from 'react';

export default class button extends React.PureComponent {  
  render() {
    return (
      <React.Fragment>
         <button type="button" aria-label={this.props.ariaLabel} id={this.props.id} tabIndex="0" disabled={this.props.disableButton} className={this.props.buttonStyle} onClick={this.props.onClick} data-track={this.props.dataTracker ? this.props.dataTracker : ''} >{this.props.buttonText}</button>
      </React.Fragment>
    );
  }
}